import React, { useState } from "react";
import "../../styles/sections/financingCard.scss";
import WhatsAppModal from "../WhatsAppFlotante/WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { buildWhatsAppUrl, getUtmParams, getCurrentUrlWithUtmDefaults } from "../../config/whatsappConfig";
import { sendToTecnom } from "../../config/tecnomApi";

const FINANCIACION_WHATSAPP_PHONE = "5493517385093";

const FinancingCard = ({
  banco,
  logo,
  color,
  etiquetas,
  titulo,
  tasa,
  tasaDestacada,
  detalle,
  detalleDestacado,
  link,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleWhatsAppClick = () => {
    setOpen(true);
  };

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const utms = getUtmParams();
      await updateData({
        ...values,
        ...utms,
        url: getCurrentUrlWithUtmDefaults(),
      });
      setOpen(false);
      const urlWithUtm = getCurrentUrlWithUtmDefaults();

      const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;

      try {
        await sendToTecnom({
          brand: "HYUNDAI",
          name: values.nombre,
          email: values.email,
          phone: values.celular,
          comments: `Consulta financiación${banco ? ` - Banco: ${banco}` : ""}`,
          tipoPlan: "venta directa",
          ...utms,
          campaign: "HYUNDAI_FINANCIACION",
        });
      } catch (tecnomError) {
        console.error("Error al enviar a Tecnóm:", tecnomError);
      }

      window.location.href = buildWhatsAppUrl(whatsappMessage, FINANCIACION_WHATSAPP_PHONE);
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="financing-card">
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
        {logo && <img src={logo} alt={banco} className="financing-card-logo" />}
      </div>
      <div className="financing-chips-container" style={{ marginBottom: 12 }}>
        {etiquetas &&
          etiquetas.map((et, i) => (
            <span key={i} className="financing-chip">
              {et}
            </span>
          ))}
        {tasaDestacada && <span className="financing-chip tasa">{tasaDestacada}</span>}
      </div>
      <div style={{ marginBottom: 12, marginTop: 12 }}>
        <p className="financing-card-title">
          {titulo}{" "}
          {tasa && (
            <span className="financing-card-tasa">
              {tasa} {detalle && <span className="financing-card-detalle">{detalle}</span>}
            </span>
          )}
        </p>
        {detalleDestacado && <div className="financing-card-detalle-destacado">{detalleDestacado}</div>}
      </div>
      <div>
        <button onClick={handleWhatsAppClick} className="financing-card-btn" disabled={loading}>
          Consultá ahora <span>→</span>
        </button>
      </div>
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
    </div>
  );
};

export default FinancingCard;
